export default __webpack_public_path__ + "static/media/feature2.44eec070.png";